import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 29 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.059 14q0-.233.072-.437.075-.204.248-.38l5.367-5.366q.32-.32.817-.32t.816.32q.321.32.321.817 0 .495-.32.816L13.83 14l4.55 4.55q.32.32.32.817 0 .495-.32.817-.322.32-.817.32t-.817-.32l-5.367-5.367a1 1 0 0 1-.248-.38A1.3 1.3 0 0 1 11.06 14" }, null, -1)
  ])))
}
export default { render: render }